import { Component, Input } from '@angular/core';
import { ApplicationDeclineTypeCode } from 'src/app/security-deposit/applications/models/applications.model';
import { ProductTypeCode } from '../../models/application-general.model';

@Component({
  standalone: false,
  selector: 'app-product-badge',
  templateUrl: './product-badge.component.html',
  styleUrls: ['./product-badge.component.scss']
})
export class ProductBadgeComponent {
  @Input()
  productTypeCode?: ProductTypeCode;

  @Input()
  declineTypeCode?: ApplicationDeclineTypeCode;

  ProductTypeCode = ProductTypeCode;
  ApplicationDeclineTypeCode = ApplicationDeclineTypeCode;

  constructor() { }
}
